import EmbeddedContent from '@components/EmbeddedContent'
import config from '@config'
import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'
import { CookWidget } from '@widgets/types'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { SportradarLineupsProps, ValidSportradarLineupsProps } from './types'
import { isValidSportradarLineupsProps } from './utils'

type CreateEmbedUrlType = (
  ...args: [matchId: ValidSportradarLineupsProps['matchId']]
) => string

const {
  sportradar: { sportradarLineupsStaticPageUrl },
} = config

const StyledSportradarLineups = styled.div`
  ${desktopCSS(css`
    min-height: 595px;
  `)}
  ${tabletCSS(css`
    min-height: 595px;
  `)}
    ${mobileCSS(css`
    min-height: 580px;
  `)}
`

const createEmbeddedUrl: CreateEmbedUrlType = (matchId) =>
  `${sportradarLineupsStaticPageUrl}?matchId=${matchId}`

const SportradarLineups: FunctionComponent<SportradarLineupsProps> = (
  props
) => {
  if (!isValidSportradarLineupsProps(props)) {
    return null
  }

  const { matchId } = props

  return (
    <StyledSportradarLineups>
      <EmbeddedContent maxHeight={500} url={createEmbeddedUrl(matchId)} />
    </StyledSportradarLineups>
  )
}

const widget: CookWidget = {
  kind: ['widget', 'sportradar-lineups'],
  component: SportradarLineups,
}

export default widget
